import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.open = false;
  }

  toggle(event) {
    this.open = !this.open;
    this.menuTarget.classList.toggle("hidden", !this.open);
    this.element.setAttribute("aria-expanded", this.open);
    event.preventDefault();
  }

  close(event) {
    if (event.type === "keydown" && event.keyCode !== 27) {
      return; // If the key is not Esc, ignore it
    }
    this.open = false;
    this.menuTarget.classList.add("hidden");
    this.element.setAttribute("aria-expanded", "false");
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close(event);
    }
  }
}
